// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remove-enrollment-sibling{width:400px}.remove-enrollment-sibling__choose{padding-bottom:20px}`, "",{"version":3,"sources":["webpack://./src/modals/RemoveEnrollmentSibling/style.scss"],"names":[],"mappings":"AAGA,2BACE,WAAA,CAEA,mCACE,mBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
